export const authSelector = state => state.auth;
